<ng-container *ngIf="target">
    <h6 class="fw-semibold text-secondary">Brennstoffzelleneinstellungen</h6>
    <div class="mt-3">
        <avs-fuelcell-cartridge-settings [target]="target"></avs-fuelcell-cartridge-settings>
    </div>
    <div class="mt-4">
        <avs-fuelcell-system-state-settings [target]="target"></avs-fuelcell-system-state-settings>
    </div>
    <div class="mt-4">
        <avs-fuelcell-battery-settings [target]="target"></avs-fuelcell-battery-settings>
    </div>
</ng-container>
